var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBgImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1280,
    height: 797,
    viewBox: "0 0 1280 797",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2208.72 0H-866.405V797.122H2208.72V0Z",
    fill: "url(#paint0_linear_1138_9915)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M704.679 275.671C1187.31 275.671 1703.11 526.285 1946.27 583.47V800.443L-831.651 800.444V729.802C-352.699 727.279 222.043 275.671 704.679 275.671Z",
    fill: "url(#paint1_linear_1138_9915)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1797.59 129.644C1634.05 116.719 1235.35 34.7719 962.192 232.289C697.737 423.513 -118.556 892.263 -856.168 907.455H-928.722C-904.638 907.964 -880.445 907.956 -856.168 907.455H1810.85L1797.59 129.644Z",
    fill: "url(#paint2_linear_1138_9915)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1138_9915",
    x1: 103.709,
    y1: -37.4716,
    x2: 90.3935,
    y2: 515.765,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AEEDE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#B1EAE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#51C4BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1138_9915",
    x1: 1892.03,
    y1: 736.991,
    x2: -804.848,
    y2: 736.988,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1643,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.776042,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.932292,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1138_9915",
    x1: 1587.21,
    y1: 326.978,
    x2: 1785.6,
    y2: 326.978,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgImage);
export default __webpack_public_path__ + "static/media/bg-image.5a14d616242aa14f5a84b07fd2cbc330.svg";
export { ForwardRef as ReactComponent };